export default "__VITE_ASSET__C$OsgR80__"